import Services from './Services';
import Objects from './Objects';
// import History from '../../../../components/HistoryTab';
import History from "../../../../pages/Ordering/common/HistoryTab"
import Comments from './Comments';

export const subTabsConfig = [
    {
        tab: 'services',
        component: Services,
        permission: true,
        translateName: 'navigation.services',
        icon: "navigation/resource",
    },
    {
        tab: 'objects',
        component: Objects,
        permission: true,
        translateName: 'navigation.objects',
        icon: 'objects',
    },
    {
        tab: 'history',
        component: History,
        permission: true,
        translateName: 'order.history',
        objectType: 'SPECIFICATION',
        icon: "history"
    },
    {
        tab: 'comments',
        component: Comments,
        permission: true,
        translateName: 'order.comments',
        icon: "comments"
    }
];